import { useSelector } from "react-redux";
import * as pathUtils from "../controller/utils/pathUtils";
import { getNodeStructure } from "../redux/slice/structureSlice";

function useNodeParent(id) {
  return useSelector(getNodeStructure(pathUtils.getIdParent(id)));
}

export default useNodeParent;
